module.exports = __webpack_public_path__ + "static/media/main.b22b704b.png";